const EditSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
      <path
        d="M8.66667 4.3334L10.6667 6.3334M11.59 5.39007C11.8526 5.12751 12.0001 4.77139 12.0001 4.40007C12.0001 4.02875 11.8526 3.67264 11.59 3.41007C11.3274 3.14751 10.9713 3 10.6 3C10.2287 3 9.87257 3.14751 9.61 3.41007L4 9.00007V11.0001H6L11.59 5.39007Z"
        stroke="#333333"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditSvg;
